import { WorkOrderQueueAPI } from "components/QueueBoard/api/workOrderApi";
import { SnackbarKey, SnackbarMessage, OptionsObject } from "notistack";

export const FINALIZED_TOAST_MESSAGE =
  "You cannot make changes to a finalized work order";
const FINALIZED_ERROR_MESSAGE =
  "Unable to verify work order status. Please try again.";

type EnqueueFn = (
  message: SnackbarMessage,
  options?: OptionsObject,
) => SnackbarKey;

export const showFinalizedToast = (enqueueSnackbar?: EnqueueFn) => {
  enqueueSnackbar?.(FINALIZED_TOAST_MESSAGE, { variant: "error" });
};

export const ensureEditableWorkOrder = async (
  invoiceDocumentIdentity?: number,
  enqueueSnackbar?: EnqueueFn,
): Promise<boolean> => {
  //debugger;
  if (!invoiceDocumentIdentity) {
    return true;
  }

  try {
    const isFinalized = await WorkOrderQueueAPI.IsWorkOrderItFinalized(
      invoiceDocumentIdentity,
    );
    if (isFinalized) {
      showFinalizedToast(enqueueSnackbar);
      return false;
    }
    return true;
  } catch (error) {
    enqueueSnackbar?.(FINALIZED_ERROR_MESSAGE, { variant: "error" });
    return false;
  }
};
